module.exports = __webpack_public_path__ + "img/app-gallery-btn.e210ed5b.svg";